import type Lenis from 'lenis'

let scroller: Lenis | null = null

export const setScroller = (instance: Lenis | null): void => {
    scroller = instance
}

/**
 * Freezes the page behind an overlay. Lenis drives the scroll itself, so
 * `overflow: hidden` on the body alone does not stop the page moving.
 */
export const setScrollLocked = (locked: boolean): void => {
    if (!scroller) return

    if (locked) {
        scroller.stop()
        return
    }

    scroller.start()
}

/** Jumps to the top of the page, going through Lenis when it is driving the scroll. */
export const resetScroll = (): void => {
    if (typeof window === 'undefined') return

    if (scroller) {
        scroller.scrollTo(0, { immediate: true })
        return
    }

    window.scrollTo(0, 0)
}
